angular.module('app').factory('ReportAccessService', function (HttpHelper) {
    return {
        saveReportAccessGrid: saveReportAccessGrid,
        getReportAccessGridAsStringList: getReportAccessGridAsStringList,
        saveReportAccessList: saveReportAccessList,
        getValidRoles: getValidRoles
    };
    function saveReportAccessGrid(grid) {
        return HttpHelper.post('api/ReportAccess/SaveReportAccessGrid', grid);
    }
    function getReportAccessGridAsStringList() {
        return HttpHelper.get('api/ReportAccess/GetReportAccessGridAsListStrings');
    }
    function saveReportAccessList(grid) {
        return HttpHelper.post('api/ReportAccess/saveReportAccessList', grid);
    }
    function getValidRoles() {
        return HttpHelper.get('api/UtpRole/GetValidRoles');
    }

});
